import { useWebhookUpdateIntegrationWebhookUpdatePostMutation } from '@shared/api';
import type { WebhookIntegrationUpdateFormValues } from '../lib/types';

export const useUpdateIntegration = () => {
  const [updateIntegrationMutation, { isLoading }] =
    useWebhookUpdateIntegrationWebhookUpdatePostMutation();

  const updateIntegration = async (
    webhookIntegrationId: number,
    values: WebhookIntegrationUpdateFormValues,
  ) => {
    try {
      await updateIntegrationMutation({
        webhookIntegrationId,
        webhookIntegrationUpdate: {
          title: values.title,
          callback_url: values.callbackUrl,
          method: values.method,
        },
      }).unwrap();
    } catch {}
  };

  return {
    updateIntegration,
    isLoading,
  };
};
